import {CommonModule} from '@angular/common'
import {NgModule} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {RouterModule} from '@angular/router'
import {NbAlertModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbIconModule, NbInputModule, NbLayoutModule} from '@nebular/theme'
import {AuthRoutingModule} from './auth-routing.module'
import {AuthComponent} from './auth.component'
import {LoginComponent} from './login/login.component'
import {SharedModule} from '../shared/shared.module';
import {LogoutComponent} from './logout/logout.component'
import {AuthenticationGuard} from './authentication.guard'
import {UserStore} from './user.store'
import {TranslateModule} from '@ngx-translate/core'

@NgModule({
  imports: [
    CommonModule,
    NbAlertModule,
    FormsModule,
    NbInputModule,
    NbCheckboxModule,
    RouterModule,
    NbIconModule,
    NbButtonModule,
    AuthRoutingModule,
    NbLayoutModule,
    NbCardModule,
    SharedModule,
    TranslateModule
  ],
  declarations: [AuthComponent, LoginComponent, LogoutComponent],
  exports: [AuthComponent, LoginComponent],
  providers: [AuthenticationGuard, UserStore]
})
export class AuthModule {}
